<template>
  <div id="phone">
    <section class="package_table" id="telePhone">
      <div class="container">
        <div class="row">
          <div class="col-md-5">
            <div class="row h-100">
              <div class="col-sm-12 align-self-center">
                <div class="title">
                  <h3>Суурин утасны үйлчилгээ</h3>
                  <div class="underline"></div>
                  <h3>IP7100 - ЯРЬ, ХЭМНЭ, МЭДЭР</h3>
                  <ul style="list-style-type: none; margin-left: 0; padding-left: 2em;">
                    <li style="margin-top: 5px; margin-bottom: 5px;">
                      <i class="fa fa-angle-double-right" style="color: #f26322;"></i>&nbsp;
                      <span>Андройд, IOS, IPPhone, компьютер зэрэг төхөөрөмжүүд дээр ашиглах боломжтой</span>
                    </li>
                    <li style="margin-top: 5px; margin-bottom: 5px;">
                      <i class="fa fa-angle-double-right" style="color: #f26322;"></i>&nbsp;
                      <span>Интернетэд суурилсан тул дэлхийн хаана ч ашиглах боломжтой</span>
                    </li>
                    <li style="margin-top: 5px; margin-bottom: 5px;">
                      <i class="fa fa-angle-double-right" style="color: #f26322;"></i>&nbsp;
                      <span>Ярианы тасалдалгүй, HD Voice, чанартай дамжуулалт</span>
                    </li>
                  </ul>
                  <p>Интернетийн төхөөрөмжид суурин утасны төхөөрөмж болон дугаар үнэгүй дагалдана..</p>
                </div>
                <!--/.title-->
              </div>
            </div>
          </div>
          <div class="col-md-7">
            <div class="swiper-container">
              <div class="swiper-wrapper">
                <div class="swiper-slide">
                  <div class="table_single">
                    <div class="table_head">
                      <h3>5,000 нэгж</h3>
                      <h4>
                        30
                        <small>хоногтой</small>
                      </h4>
                    </div>
                    <ul>
                      <li></li>
                      <li></li>
                    </ul>
                    <a href="#" class="btn">АВАХ</a>
                  </div>
                  <!--/.table_single-->
                </div>
                <div class="swiper-slide">
                  <div class="table_single">
                    <div class="table_head">
                      <h3>10,000 нэгж</h3>
                      <h4>
                        30
                        <small>хоногтой</small>
                      </h4>
                    </div>
                    <ul>
                      <li></li>
                      <li></li>
                    </ul>
                    <a href="#" class="btn">АВАХ</a>
                  </div>
                  <!--/.table_single-->
                </div>
                <div class="swiper-slide">
                  <div class="table_single">
                    <div class="table_head">
                      <h3>20,000 нэгж</h3>
                      <h4>
                        60
                        <small>хоногтой</small>
                      </h4>
                    </div>
                    <ul>
                      <li></li>
                      <li></li>
                    </ul>
                    <a href="#" class="btn">АВАХ</a>
                  </div>
                  <!--/.table_single-->
                </div>
                <div class="swiper-slide">
                  <div class="table_single">
                    <div class="table_head">
                      <h3>5,000 нэгж</h3>
                      <h4>
                        <small>хоноггүй</small>
                      </h4>
                    </div>
                    <ul>
                      <li></li>
                      <li></li>
                    </ul>
                    <a href="#" class="btn">АВАХ</a>
                  </div>
                  <!--/.table_single-->
                </div>
              </div>
              <!--/.swiper-wrapper-->
            </div>
          </div>
        </div>
      </div>
      <!--/.container-->
      <!-- <PhoneNumber/> -->
    </section>
  </div>
</template>

<script>
// import PhoneNumber from "@/components/PhoneNumber.vue";

export default {
  name: "phone",
  // components: {
  //   PhoneNumber
  // }
};
</script>